import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=6b34130e&scoped=true&"
import script from "./Recipients.vue?vue&type=script&lang=js&"
export * from "./Recipients.vue?vue&type=script&lang=js&"
import style0 from "./Recipients.vue?vue&type=style&index=0&id=6b34130e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34130e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b34130e')) {
      api.createRecord('6b34130e', component.options)
    } else {
      api.reload('6b34130e', component.options)
    }
    module.hot.accept("./Recipients.vue?vue&type=template&id=6b34130e&scoped=true&", function () {
      api.rerender('6b34130e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/lot/components/Recipients.vue"
export default component.exports